import React, { useState } from 'react';
import ModalBasic from '../../components/infrastructure/Modals/ModalBasic';
import { FieldArray, FormikProvider, useFormik } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import { PURCHASE_ORDER_STATUS } from '../../utils/dropdownOptions';
import PrimaryButton from '../../components/infrastructure/Buttons/PrimaryButton';
import { ClipLoader } from 'react-spinners';
import FormikSelectGroup from '../../components/formik/FormikSelectGroup';
import {
    editPurchaseOrder,
    fetchPurchaseOrders,
} from '../../app/reducers/PurchaseOrder/purchaseOrderSlice';
import FormikTextareaGroup from '../../components/formik/FormikTextareaGroup';
import FormikDirectFileUploadWithTakePhoto from '../../components/formik/FormikDirectFileUploadWithTakePhoto';
import { RxCross2 } from "react-icons/rx";
import { getAuth } from '../../app/reducers/Auth/authSlice';
import DocumentPreview from '../Products/DocumentPreview';

const PurchaseOrderStatusModal = ({
    isStatusModalOpen,
    setIsStatusModalOpen,
    purchaseOrderStatusData,
    page,
    currentStatus,
    onSuccess = () => { },
}) => {
    const [previewImg, setPreviewImg] = useState(null);
    const [openDocumentPreviewModal, setOpenDocumentPreviewModal] = useState(false);

    const currentStatusIndex = PURCHASE_ORDER_STATUS.findIndex(
        (item) => item.value == purchaseOrderStatusData.status
    );
    const { user } = useSelector(getAuth);
    // console.log("user", user)
    const nextStatus =
        PURCHASE_ORDER_STATUS[
            currentStatusIndex != PURCHASE_ORDER_STATUS.length - 1
                ? currentStatusIndex + 1
                : currentStatusIndex
        ].value;
    const dispatch = useDispatch();
    // console.log("currentStatus", currentStatus)
    const statusFormik = useFormik({
        enableReinitialize: true,
        initialValues: {
            ...purchaseOrderStatusData, status: nextStatus ?? '',
            dispatchPhotos: purchaseOrderStatusData?.dispatchPhotos || [],
            dispatchNote: purchaseOrderStatusData?.dispatchNote ?? '',
        },
        onSubmit: async (values) => {
            try {
                console.log("value", values)
                const filteredValues = {
                    ...values,
                    dispatchPhotos: values.dispatchPhotos.filter((photo) => photo !== '' && photo !== null && photo !== undefined),
                };
                console.log("filteredValues", filteredValues)
                await dispatch(editPurchaseOrder(filteredValues));
                statusFormik.resetForm();
                setIsStatusModalOpen(false);
                await onSuccess();
            } catch (error) {
                console.log("error", error)
            }
        },
    });
    console.log("purchaseOrderStatusData", purchaseOrderStatusData)
    return (
        <ModalBasic
            setModalOpen={setIsStatusModalOpen}
            modalOpen={isStatusModalOpen}
            title={'Update Status'}
        >
            <DocumentPreview
                previewModalOpen={openDocumentPreviewModal}
                setPreviewModalOpen={setOpenDocumentPreviewModal}
                previewImg={[previewImg]}
            />
            <form
                onSubmit={statusFormik.handleSubmit}
                className="flex flex-col gap-2 p-3"
            >
                <FormikSelectGroup
                    formik={statusFormik}
                    name={'status'}
                    label="Status"
                    options={PURCHASE_ORDER_STATUS}
                    isDisabled={user?.role === 'delivery_executive'}
                />

                {purchaseOrderStatusData?.dispatchPhotos && currentStatus === 'delivered' &&
                    <div className="flex gap-2">
                        {purchaseOrderStatusData?.dispatchPhotos?.map((photo, index) => (
                            <img
                                key={index}
                                src={`${process.env.REACT_APP_S3_URL}${photo}`}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    setPreviewImg(photo);
                                    setOpenDocumentPreviewModal(true)
                                }}
                                alt="Dispatch Images"
                                className="w-24 h-24 object-contain rounded cursor-pointer border hover:opacity-80"
                            />
                        ))}
                    </div>
                }
                {currentStatus === "dispatch" && (
                    <FormikProvider value={statusFormik}>
                        <FieldArray
                            name="dispatchPhotos"
                            render={(arrayHelpers) => (
                                <div className="flex flex-col gap-3">
                                    {statusFormik.values.dispatchPhotos?.map((ele, i) => (
                                        <div
                                            key={i}
                                            className="flex items-center gap-2"
                                        >
                                            <FormikDirectFileUploadWithTakePhoto
                                                label={`Photo ${i + 1}`}
                                                formik={statusFormik}
                                                name={`dispatchPhotos.${i}`}
                                                randomize
                                                location={"purchase_order/"}
                                            />

                                            <RxCross2
                                                type="button"
                                                size={20}
                                                color='red'
                                                className="cursor-pointer "
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    arrayHelpers.remove(i)
                                                }}
                                            />
                                        </div>
                                    ))}

                                    <div>
                                        <PrimaryButton
                                            type="button"
                                            className="px-1 py-1 text-sm m-4"
                                            onClick={() => arrayHelpers.push('')}
                                        >
                                            Add Dispatch Photo
                                        </PrimaryButton>
                                    </div>
                                </div>
                            )}
                        />
                    </FormikProvider>
                )}
                <FormikTextareaGroup
                    formik={statusFormik}
                    name={'dispatchNote'}
                    label="Message"
                    readOnly={user?.role === 'delivery_executive'}
                // readOnly={statusFormik.values.status !== 'dispatch'}
                />
                <div className="mb-2">
                    <PrimaryButton type="submit">Submit</PrimaryButton>
                </div>
            </form>
        </ModalBasic>
    );
};

export default PurchaseOrderStatusModal;
